/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brand: NonNullable<unknown>, last4: NonNullable<unknown> }} Plan_Card_Ending_InInputs */

const en_plan_card_ending_in = /** @type {(inputs: Plan_Card_Ending_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brand} ending in ${i?.last4}`)
};

const es_plan_card_ending_in = /** @type {(inputs: Plan_Card_Ending_InInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.brand} terminada en ${i?.last4}`)
};

/**
* | output |
* | --- |
* | "{brand} ending in {last4}" |
*
* @param {Plan_Card_Ending_InInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_card_ending_in = /** @type {((inputs: Plan_Card_Ending_InInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Card_Ending_InInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_card_ending_in(inputs)
	return en_plan_card_ending_in(inputs)
});